/**
 * Patient data service
 * Handles patient CRUD operations.
 * Uses Firestore users collection with role=patient.
 */

import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./firebase";

/**
 * Get all patients for a doctor
 * @param {string} doctorId
 * @returns {Array}
 */
export const getDoctorPatients = async (doctorId) => {
  const q = query(
    collection(db, "users"),
    where("role", "==", "patient"),
    where("doctorId", "==", doctorId)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const subscribeDoctorPatients = (doctorId, onData, onError) => {
  const q = query(
    collection(db, "users"),
    where("role", "==", "patient"),
    where("doctorId", "==", doctorId)
  );

  return onSnapshot(
    q,
    (snapshot) => {
      const patients = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      onData(patients);
    },
    (error) => {
      if (onError) onError(error);
    }
  );
};

/**
 * Get patient by ID
 * @param {string} patientId
 * @returns {Object}
 */
export const getPatient = async (patientId) => {
  const snap = await getDoc(doc(db, "users", patientId));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};

/**
 * Update patient
 * @param {string} patientId
 * @param {Object} updates
 */
export const updatePatient = async (patientId, updates) => {
  await updateDoc(doc(db, "users", patientId), updates);
};
